import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useState } from "react";
import CompanyInfo from "./CompanyInfo";
import PaymentMethod from "./PaymentMethod";

import "./styles.scss";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB);

const PaymentInfoModal = ({ onClose, onPaymentSucceed }) => {
  const [step, setStep] = useState(1);

  return (
    <Dialog
      open={true}
      onClose={onClose}
      className="PaymentInfoModal"
      fullWidth
      maxWidth="md"
    >
      <DialogContent>
        <div className="PaymentInfoModal__steps">Paso {step} de 2</div>
        {step === 1 ? (
          <CompanyInfo onSubmitSuccess={() => setStep(2)} />
        ) : (
          <Elements stripe={stripePromise}>
            <PaymentMethod
              onClose={onClose}
              onPaymentSucceed={onPaymentSucceed}
            />
          </Elements>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PaymentInfoModal;
